import React, { useState } from "react";
import { downloadFile } from "../../utils/media";
import { canDownloadMedia } from "../../utils/roleUtils";
import "./MediaField.css";

const DownloadButton = ({ url, label = "Download", className = "" }) => {
  const [busy, setBusy] = useState(false);

  if (!url || !canDownloadMedia()) return null;

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    await downloadFile(url);
    setBusy(false);
  };

  return (
    <button
      type="button"
      className={`download-btn ${className}`}
      onClick={handleClick}
      disabled={busy}
      title="Download file"
    >
      <span aria-hidden="true">⬇</span> {busy ? "..." : label}
    </button>
  );
};

export default DownloadButton;
